import React, {Component} from 'react';

import {dt, getCode} from 'l10n';

export default function RegionSelect(props) {
    let localeCode = getCode();

    let {name, onChange, value, defaultValue, regions} = props;

    const Separator = () => <React.Fragment>
        <option style={{fontSize: '3pt'}} disabled/>
        <option style={{backgroundColor: '#ccc', fontSize: '1pt'}} disabled/>
        <option style={{fontSize: '3pt'}} disabled/>
    </React.Fragment>

    const splitRegions = rearrangeObjects(regions);

    function rearrangeObjects(array) {
        const metropolitan = array.filter((obj) => obj.type === 'metropolitan')

        const overseas = array.filter((obj) => obj.type === 'overseas')

        if (!metropolitan.length || !overseas.length) return array

        if (overseas.length) {
            // @ts-ignore
            overseas[0].topLine = true
        }
        return metropolitan.concat(overseas)
    }

    return (
        <select name={name} onChange={onChange} defaultValue={defaultValue} value={value}>
            <option value="">{dt('location_select', 'Any')}</option>
            {splitRegions && splitRegions.length && splitRegions.map((region) => {
                if (region.topLine) return (<React.Fragment key={region.topLine}>
                    <Separator />
                    <option value={region.code} key={region.code}>{region[localeCode]}</option>
                </React.Fragment>)
                return (<React.Fragment key={region.topLine}>
                    <option value={region.code} key={region.code}>{region[localeCode]}</option>
                </React.Fragment>)
            })}
        </select>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/RegionSelect.js